<template>
  <div class="form-elements">
    <div>
        <sp-360-panel :title="'management.localization.manageLocalization' | translate">
            <div class="row">
                <div class="flex lg12 md12 sm12" style="margin-top:1rem;">
                  <v-jsoneditor v-model="localizacao" :options="options" :plus="false" height="600px" @error="onError"/>
                  <fieldset>
                      <div class="row">
                        <div class="flex lg6">
                            <va-button type="button" @click="limpar()" class="btn btn-primary btn-sm pull-left">
                              {{'management.revertChanges'| translate}}
                            </va-button>
                        </div>
                        <div class="flex lg6">
                            <va-button type="button" :disabled="isBtnSaveDisabled" @click="alterarLocalizacao()" class="btn btn-primary btn-sm pull-right">
                              {{'management.save'| translate}}
                            </va-button>
                        </div>
                      </div>
                  </fieldset>
                </div>
            </div>
        </sp-360-panel>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import VJsoneditor from 'v-jsoneditor/src/index'
import Multiselect from 'vue-multiselect'
import constantes from '@/utils/ConstantesGlobais'
import MetodosGlobais from '@/utils/MetodosGlobais'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'

export default {
  components: { VJsoneditor, Sp360Panel },
  name: 'localizacao',
  computed: {

  },
  data () {
    return {
      isBtnSaveDisabled: true,
      options: {
        onValidationError: function (errors) {
          this.setStatus(errors)
        }.bind(this),
        modes: ['tree', 'code'],
        languages: constantes.JSONEDITOR_LOCALIZACAO
      },
      openModalDelecao: false,
      localizacao: {},
      localizacaoInicial: {},
      dadoRequest: {},
    }
  },
  beforeCreate () {
    this.$store.dispatch('parametrizacao/getLocalizacaoPadrao').then(dado => {
      this.dadoRequest = dado
      this.localizacaoInicial = JSON.parse(dado.internacionalizacao)
      this.localizacao = JSON.parse(dado.internacionalizacao)
    })
  },
  methods: {
    onError (error) {
    },
    setStatus (errors) {
      if (errors.length > 0) { this.isBtnSaveDisabled = true } else { this.isBtnSaveDisabled = false }
    },
    showSmallModal () {
      this.$refs.smallModal.open()
    },
    alterarLocalizacao () {
      event.preventDefault()
      let iguais = _.isEqual(this.localizacaoInicial, this.localizacao)
      if (this.isBtnSaveDisabled) {
        this.showToast(this.$t('management.localization.invalidJson'), constantes.TOASTED_ERROR)
      } else if (iguais) {
        this.isBtnSaveDisabled = true
        this.showToast(this.$t('management.noChangesDetected'), constantes.TOASTED_ERROR)
      } else {
        this.dadoRequest.internacionalizacao = JSON.stringify(this.localizacao)
        this.$store.dispatch('parametrizacao/putLocalizacao', this.dadoRequest)
          .then(retorno => {
            this.showToast(this.$t('management.localization.standardLocalization') + this.$t('management.updated'), constantes.TOASTED_SUCCESS)
            this.localizacaoInicial = _.cloneDeep(this.localizacao)
          })
          .catch(err => {
            console.error(err)
            this.showToast(this.$t('management.updatedError'), constantes.TOASTED_ERROR)
          })
      }
      this.isBtnSaveDisabled = false
    },
    deletarModal (event) {
      this.privilegioADeletar = event.rowData
      this.openModalDelecao = true
    },
    limpar () {
      this.localizacao = this.localizacaoInicial
    },
  },
}
</script>
